import type { TenantConfig } from '@/types/TenantConfig'

const primaryColor = '#A20067'
const secondaryColor = '#003057'

export const mos: TenantConfig = {
  logo: {
    large: 'assets/mos/static/logo.svg',
    small: 'assets/mos/static/mobile-logo.svg',
  },
  teaserImageSize: {
    width: 380,
    height: 343,
  },

  themeOptions: {
    headerHeight: '120px',
    dialog: {
      headerTextColor: primaryColor,
      headerIconColor: primaryColor,
      backgroundColor: 'white',
    },
    mobileFooter: {
      cartButtonBorder: `1px solid ${secondaryColor}`,
      cartButtonIconColor: 'black',
      textColor: 'black',
      priceTextColor: 'black',
    },
    backButton: {
      iconColor: primaryColor,
    },
  },
  componentOptions: {
    stripeCreditCard: {
      fontFaceStylesheet: 'https://use.typekit.net/tsu4pxd.css',
    },
    eventDetailRoute: {
      eventNameTitlePosition: 'inside content',
    },
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/mos/static/completed.jpg',
      },
      completedContentOffset: {
        desktop: '-300px',
        mobile: '-150px',
      },
    },
  },
}
